export default __webpack_public_path__ + "static/media/Montserrat-Regular.24785cc0.ttf";